import { render, staticRenderFns } from "./HeaderElement.vue?vue&type=template&id=063f9653&scoped=true"
import script from "./HeaderElement.vue?vue&type=script&lang=js"
export * from "./HeaderElement.vue?vue&type=script&lang=js"
import style0 from "./HeaderElement.vue?vue&type=style&index=0&id=063f9653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f9653",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Arrow: require('/home/node/app/assets/icons/arrow.vue').default,ControllerNavigationBar: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerNavigationBar.js').default,Profile: require('/home/node/app/assets/icons/profile.vue').default,Cart: require('/home/node/app/assets/icons/cart.vue').default,ControllerCart: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerCart.js').default,ControllerHeader: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerHeader.js').default})
